import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { OrganisationService } from "../create-organisation/organisation.service";
import { DamserviceService } from "../dam/damservice.service";
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-workspaces',
  templateUrl: './workspaces.component.html',
  styleUrls: ['./workspaces.component.css']
})
export class WorkspacesComponent implements OnInit {

  notifications = [];
  showLoader: boolean = false;
  mobileViewSection: boolean = false;

  currentUser: User;
  currentValue: string
  workspacename: string = '';
  mobileView: boolean = false;
  loginStyle = "none";
  workspace_token: string;
  workspaceCount: any;
  workspaces = [];
  totalSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  totalAllowedInvites: any;
  workspaceCountAllowed: any;
  consumedSpaceAllowed: any;
  planId: any;
  planName: String;
  ownerEmail: String;
  ownerName: String;
  userPic: any;
  workspaceId: any;
  workspaceName: string;
  userRole: string;
  edittedWorkspaceName: string = '';
  edittedWorkspaceFirstName: string = '';
  edittedWorkspaceLastName: string = '';
  edittedWorkspaceEmail: string = '';
  boards = [];
  isMobile: any;
  createWorkspaceStyle = "none";
  isShowCreateWorkspaceError: boolean = false
  createWorkspaceErrorMessage: string;
  isShowCreateLoginWorkspaceError: boolean = false
  createWorkspaceLoginErrorMessage: string;
  showLeaveLoader: boolean = false;

  createWorkspaces = this.fb.group({
    message: ['', Validators.required],
  });

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private titleService: Title,
    private metaTagService: Meta,
    private authService: AuthService,
    private organisationService: OrganisationService,
    private damService: DamserviceService,
    private fb: FormBuilder,
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  ngOnInit(): void {
    this.titleService.setTitle("Workspaces | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Create a workspace with a unique name and get access to the workspace to create boards and upload your work like images, illustrations, etc.'},
      { name: 'keywords', content: 'create workspace, workspace, dam, DAM, digital assets management, assets, digital' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) {
      this.mobileView = true;
    }else{
      this.mobileView = false;
    }

    if (this.isMobile) {
      this.mobileViewSection = true;
      this.mobileView = true;
    }else{
      this.mobileViewSection = false;
      this.mobileView = false;
    }

    if (this.currentUser) {
      this.getWorkspaceDetails();
      this.getUserPic();
      this.currentValue = "Logout";
    }else{
      this.router.navigate(['/login']);
      this.currentValue = "Login";
    }
  }

  loginLogout(){
    if (this.currentUser) {
      this.authenticationService.logout();
      this.authService.signOut();
      this.currentValue = "Login";
    }else{
      this.currentValue = "Logout";
    }
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    this.edittedWorkspaceName = details.workspaceName;
    this.getCurrentUserData(this.workspaceId);
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  getCurrentUserData(workspaceId: any) {
    this.damService.getCurrentUserData(workspaceId).subscribe((data: any) => {
      this.userRole = data.role;
      this.edittedWorkspaceEmail = data.email;
      this.listWorkspace();
      this.ownerListApi();
      // this.damService.getBoardsList(this.workspaceId).subscribe((data: any) => {
      //   this.boards = data;
      // });
    },
    (error) => {
      if(error.status == 500){
        // this.router.navigate(['/maintenance']);
      } else {

      }
    });
  }

  listWorkspace(){
    this.organisationService.getWorkspaceList().subscribe((data: any) => {
      if(data.length > 0){
        this.workspaces = data;
        this.workspaceCount = data.length;
      }else{
        // this.router.navigate(['/create-workspace']);
      }
    });
  }

  ownerListApi(){
    this.damService.getOwnerList(this.workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
      this.totalAllowedInvites = data.allowed_seats;
      this.planId = data.plan_id;
      this.workspaceCountAllowed = data.allowed_workspace;
    });
  }

  launchWorkspace(title: string, id: any, role: string){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: id,
      workspaceName: title, userRole: role }));
    this.router.navigate(['/dam']);
  }

  backToWorkspace() {
    this.router.navigate(['/dam']);
  }

  personalClick(){
    localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
      workspaceName: this.workspaceName, userRole: this.userRole }));
    this.router.navigate(['/dam/personal']);
  }

  getInitials(fullEmail: string) {
    const words = fullEmail.split(' ');
    let initials = '';

    if (words.length > 2) {
      initials = words.slice(0, 2).map(word => word.charAt(0)).join('').toUpperCase();
    } else {
      initials = words.map(word => word.charAt(0)).join('').toUpperCase();
    }

    return initials;
   }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  openFigma() {
    window.open("https://www.figma.com/community/plugin/902086023682633830/Crafttor", "_blank");
  }

  openSketch() {
    window.open("https://crafttor.com/sketch", "_blank");
  }

  openIllustrator() {
    window.open("https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator", "_blank");
  }

  getNotifications() {
    this.showLoader = true;
    this.newNotification();
  }

  newNotification () {
    this.damService.newNotifications(this.workspaceId).subscribe((data: any) => {
      this.notifications = data['notifcation'];
      this.showLoader = false;
    });
  }

  getName(fullEmail: string) {
    return fullEmail.split(' ').map(n => n[0]).join('').toUpperCase();
  }

  getRandomColor() {
    var color = Math.floor(0x1000000 * Math.random()).toString(16);
    return '#' + ('000000' + color).slice(-6);
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }

  openNewWorkspaceDialog() {
    this.createWorkspaceStyle = "block";
  }

  closeNewWorkspaceDialog() {
    this.createWorkspaceStyle = "none";
  }

  // createWorkspace() {
  //   localStorage.setItem('workspaceCreationScreenDetails', JSON.stringify({ screenId: 1}));
  //   this.router.navigate(['/create-workspace']);
  // }

  createWorkspace(workspaceName: any){
    if (this.currentUser) {
      if(this.createWorkspaces.valid) {
        this.showLeaveLoader = true;
        this.isShowCreateWorkspaceError = false
        this.organisationService.createNewWorkspace(workspaceName).subscribe((data: any) => {
          this.showLeaveLoader = false;
          this.createWorkspaces.reset();
          localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: data.id,
            workspaceName: data.title, userRole: data.role }));
          this.router.navigate(['/dam']);
          this.closeNewWorkspaceDialog();
        },
        (error) => {
          if(error.status == 403){
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          } else {
            this.showLeaveLoader = false;
            this.isShowCreateWorkspaceError = true
            this.createWorkspaceErrorMessage = error.error.Message;
          }
       });
      }
    }else{
      this.isShowCreateLoginWorkspaceError = true
      this.createWorkspaceLoginErrorMessage = "Login to Continue";
    }
  }

  showUpgradePlans(){
    window.scrollTo(0, 0);
    if (this.currentUser) {
      localStorage.setItem('workspaceDetails', JSON.stringify({ workspaceId: this.workspaceId,
        workspaceName: this.workspaceName, userRole: this.userRole }));
      this.router.navigate(['/dam/subscription']);
    }
  }
}
